import _ from 'lodash';
export function createNodeWithClass(tagName, cssClass, id) {
    const node = document.createElement(tagName);
    node.className = cssClass;
    if (id) {
        node.setAttribute('id', id);
    }
    return node;
}
export function getDOMClassesFromSelector(selector) {
    return selector.replace(/\./, '').replace(/\./g, ' ');
}
export function getTextContentFromHTML(innerHTMLText) {
    const div = document.createElement('div');
    div.innerText = innerHTMLText;
    return div.textContent || div.innerText || '';
}
export function getImageFromBase64(data) {
    const uri = `data:image/png`;
    return `${uri};base64, ${data}`;
}
export function getTransitionEndEvt() {
    const root = document.documentElement;
    const transitions = {
        transition: 'transitionend',
        OTransition: 'oTransitionEnd',
        MozTransition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
    };
    const value = Object.keys(transitions).filter(key => {
        if (root.style[key] !== undefined) {
            return true;
        }
        return false;
    });
    return value.length > 0 ? transitions[value[0]] : undefined;
}
export const getEventPath = (e) => {
    let path = e.path || (_.isFunction(e.composedPath) && e.composedPath());
    if (!path) {
        path = [];
        let el = e.target;
        while (el) {
            path.push(el);
            if (el.tagName === 'HTML') {
                path.push(document);
                path.push(window);
                return path;
            }
            el = el.parentNode;
        }
    }
    return path;
};
export function inIFrame() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
export async function copyToClipboard(text, onCopy) {
    if (!_.isString(text)) {
        return;
    }
    const textArea = document.createElement('textarea');
    textArea.style.position = 'absolute';
    textArea.style.left = '-1000px';
    textArea.style.top = `${document.body.scrollTop}px`;
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    textArea.focus();
    try {
        await navigator.clipboard.writeText(textArea.value);
    }
    catch (error) {
        document.execCommand('copy');
    }
    setTimeout(() => {
        textArea.parentNode.removeChild(textArea);
        if (onCopy) {
            onCopy();
        }
    }, 100);
}
export var LINK_TARGET;
(function (LINK_TARGET) {
    LINK_TARGET["SELF"] = "_self";
    LINK_TARGET["BLANK"] = "_target";
})(LINK_TARGET || (LINK_TARGET = {}));
export const getHyperLinkAndCaption = (caption, link, target = LINK_TARGET.BLANK) => {
    if (caption && link) {
        const captionLabel = caption.replace(new RegExp('<[^>]*>', 'g'), '');
        const hyperlink = document.createElement('a');
        hyperlink.innerText = captionLabel;
        hyperlink.setAttribute('href', encodeURI(link));
        hyperlink.setAttribute('style', 'text-decoration: underline');
        hyperlink.setAttribute('rel', 'noopener');
        hyperlink.setAttribute('target', target);
        return {
            hyperlink,
            caption: captionLabel,
        };
    }
    return undefined;
};
export const cleanHTMLTags = (HTMLString) => {
    if (!HTMLString) {
        return HTMLString;
    }
    return (new DOMParser()?.parseFromString(HTMLString, 'text/html')
        .documentElement?.textContent || HTMLString);
};
export const downloadFileUtil = (file) => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(file.blob);
    a.setAttribute('download', `${file.fileName}`);
    a.setAttribute('style', 'display:none');
    a.click();
    URL.revokeObjectURL(a.href);
};
export const getFileName = (disposition) => {
    let filename = '';
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    filename = filename.trim();
    if (filename.includes('UTF-8')) {
        filename = filename.replace('UTF-8', '');
        filename = decodeURIComponent(filename);
    }
    return filename;
};
//# sourceMappingURL=browser-util.js.map